<template>
  <b-navbar toggleable="lg" type="dark" class="navigation">

  <modal-login v-if="!isUserLoggedIn"></modal-login>

    <b-navbar-brand :href="websiteLink">
      <img src="@/assets/img/logo.png" height="30" />
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>

      <b-navbar-nav class="align-items-center">
        <b-nav-item to="/">Donate</b-nav-item>
        <b-nav-item to="/faq">FAQ</b-nav-item>
        <b-nav-item to="/history">History</b-nav-item>
        <template v-if="!isUserLoggedIn">
          <!-- NOT LOGGED IN -->
        </template>
        <template v-else-if="user">
          <b-nav-item to="/dashboard">Dashboard</b-nav-item>
        </template>

        <template v-if="isUserAdmin">
          <b-nav-item to="/admin">Admin</b-nav-item>
        </template>

      </b-navbar-nav>

      <b-navbar-nav class="ml-auto align-items-center">

        <template v-if="!isUserLoggedIn">
          <b-nav-item v-b-modal.modal-login>Login</b-nav-item>
        </template>
        <template v-else-if="user">
          <b-img v-b-popover.hover.bottom="userPopoverData" class="mr-2" rounded="circle" alt="Steam Avatar" blank-color="black" width="32" height="32" :src="user.avatar_url"></b-img>
          <b-nav-item @click="logout">Logout</b-nav-item>
        </template>

      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import UserApi from '@/services/UserApi'
import EventBus from '@/services/EventBus'

const ModalLogin = () => import(
  './Modals/Login.vue'
);

export default {
  async created() {
    UserApi.getData().then((user) => {
      this.user = user;
    }).catch(error => {
      EventBus.$emit('Error', error);
    })
  },
  data() {
    return {
      user: [],
      websiteLink: process.env.LOGO_LINK,
    }
  },
  computed: {
    isUserAdmin() {
      return UserApi.isAdmin();
    },
    isUserLoggedIn() {
      return UserApi.isLoggedIn();
    },
    userPopoverData() {
      return {
        content: this.user.username
      }
    }
  },
  methods: {
    logout() {
      UserApi.logout();
    }
  },
  components: {
    ModalLogin
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Stock/Navigation.vue